export default __webpack_public_path__ + "static/media/link.82c23d5b.svg";